import { Component, Prop } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component({
    template: '<div id="g-re-captcha"></div>',
})
export default class Recaptcha extends BaseComponent {
    @Prop({ type: String, required: true }) protected sitekey: string;
    @Prop({ type: String, default: 'light' }) protected theme: string;
    @Prop({ type: String, default: 'normal' }) protected size: string;

    public mounted(): void {
        window.grecaptcha.render(this.$el, {
            sitekey: this.sitekey,
            theme: this.theme,
            size: this.size,
            callback: (captchaResponse) => {
                this.$emit('response', captchaResponse);
            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/Recaptcha.ts